import React, { useRef, useState } from "react";
import { api } from "../lib/api";
import { UploadSimple, X } from "@phosphor-icons/react";
import { toast } from "sonner";

// `value` is the stored URL — either a relative app path (/api/media/abc, /uploads/x.png)
// or an absolute external URL (https://...). `onChange(url)` is called when
// the user uploads a new file, pastes a URL, or clears it.
export default function ImageUpload({ value, onChange, label = "Image" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      setBusy(true);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      // Store as relative URL so images work on any host (mpsound.eu,
      // emergent.host, future domains) without depending on REACT_APP_BACKEND_URL.
      onChange(data.url);
      toast.success("Uploaded");
    } catch (e) {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const preview = value;

  return (
    <div className="border border-[#2a2a35] p-3 bg-[#0a0a0c]">
      <div className="flex items-center justify-between mb-2">
        <div className="label-tag">{label}</div>
        {preview && (
          <button type="button" onClick={() => onChange("")} className="text-gray-500 hover:text-[#ff003c]" data-testid="image-clear">
            <X size={14} />
          </button>
        )}
      </div>
      {preview ? (
        <div className="relative">
          <img src={preview} alt="" className="w-full max-h-44 object-cover" />
        </div>
      ) : (
        <div className="aspect-video bg-[#121216] border border-dashed border-[#2a2a35] flex items-center justify-center text-gray-500 mono-font text-xs">
          NO IMAGE
        </div>
      )}
      <div className="flex gap-2 mt-3">
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => upload(e.target.files?.[0])}
          data-testid="image-upload-input"
        />
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          className="flex-1 btn-outline justify-center"
          data-testid="image-upload-btn"
        >
          <UploadSimple size={16} weight="bold" /> {busy ? "..." : "Upload"}
        </button>
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="…or paste URL"
          className="input-dark flex-1"
        />
      </div>
    </div>
  );
}
